var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCubesLg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 841,
    height: 420,
    viewBox: "0 0 841 420",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_24786_52691)"
  }, /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    width: 168.032,
    height: 168,
    transform: "matrix(-1 0 0 1 672.199 84.0078)",
    fill: "#F5F7FA"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    width: 84.016,
    height: 168,
    transform: "matrix(-1 0 0 1 588.113 168)",
    fill: "#F5F7FA"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 420.08,
    height: 84,
    transform: "matrix(-1 0 0 1 420.078 252)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.9,
    x: 420.078,
    width: 84.016,
    height: 84,
    fill: "#F5F7FA"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 504.098,
    width: 84.016,
    height: 84,
    fill: "#F5F7FA"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.8,
    width: 84.016,
    height: 84,
    transform: "matrix(-1 0 0 1 504.098 252)",
    fill: "#F5F7FA"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.8,
    width: 84.016,
    height: 84,
    transform: "matrix(-1 0 0 1 336.062 336)",
    fill: "#F5F7FA"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    width: 84.016,
    height: 84,
    transform: "matrix(-1 0 0 1 420.078 336)",
    fill: "#F5F7FA"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 300,
    height: 84,
    transform: "matrix(-1 0 0 1 300 336)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 504.096,
    height: 168,
    transform: "matrix(-1 0 0 1 504.098 84)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 420.08,
    height: 84,
    transform: "matrix(-1 0 0 1 420.078 0)",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_24786_52691"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 841,
    height: 420,
    fill: "white",
    transform: "matrix(1 0 0 -1 0 420)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCubesLg);
export default __webpack_public_path__ + "static/media/cubesLg.1563a0cf87536cc1b23d0bff62dbf8de.svg";
export { ForwardRef as ReactComponent };